import { cloneElement } from "react";

import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import DropdownMenuItem from "@rui/Dropdown/DropdownMenuItem";
import { DropdownItem } from "@rui/Dropdown/types";
import Menu, { MenuBody } from "@rui/Menu";

const SortByMenu = ({
  children,
  options,
  selectedSort,
  onChange,
}: {
  children: React.ReactElement;
  options: DropdownItem[];
  selectedSort: DropdownItem;
  onChange: (e: React.MouseEvent<HTMLElement>, id: string) => void;
}) => {
  const { anchorElement, onClick, open, onClose } = useAnchorElement();

  const openMenuButton = cloneElement(children, { onClick });
  const handleClickMenuItem =
    (newValue: string) => (event: React.MouseEvent<HTMLElement>) => {
      onClose();
      onChange(event, newValue);
    };

  return (
    <>
      {openMenuButton}
      <Menu
        open={open}
        onClose={onClose}
        anchorEl={anchorElement}
        disablePadding
      >
        <MenuBody sx={{ px: 0.5, py: 1, minWidth: "200px" }}>
          {options.map((option) => {
            const isSelected = selectedSort.value === option.value;
            return (
              <DropdownMenuItem
                onClick={handleClickMenuItem(option.value)}
                key={option.value}
                selected={isSelected}
                {...option}
              />
            );
          })}
        </MenuBody>
      </Menu>
    </>
  );
};

export default SortByMenu;
